const unescapeAttribute = (text) => {
    const result = text
      .replaceAll(`&quot;`, `"`)
      .replaceAll( `&lt;`, `<`)
      .replaceAll(`&gt;`, `>`)
      .replaceAll( `&amp;`, `&`);
  
      return result;
  }

export default unescapeAttribute;